import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Card, CardBody, Col, Row,
} from 'reactstrap';
import ReactTableBase from 'src/shared/components/table/ReactTableBase';
import { useTranslation } from 'react-i18next';

const SubscriptionView = ({ reactTableData, isNoRecordFound }) => {
  const [rows] = useState(reactTableData && reactTableData?.tableRowsData ? reactTableData.tableRowsData : null);
  const { t } = useTranslation('common');

  const tableConfig = {
    isEditable: false,
    isSortable: false,
    isResizable: false,
    withPagination: true,
    withSearchEngine: true,
    manualPageSize: [10, 50, 100, 1000],
    placeholder: '',
  };
  return (
    <Col md={12} lg={12}>
      <Card>
        <CardBody>
          <Row>
            <Col md={12}>
              <h3 className="page-title">Subscription Details</h3>
            </Col>
          </Row>

          {!isNoRecordFound && rows &&
            <ReactTableBase
              name={t('instution_type.view.name_map')}
              key={'searchable'}
              columns={reactTableData.tableHeaderData}
              data={rows}
              tableConfig={tableConfig}
            />
          }

        </CardBody>
      </Card>
    </Col>
  );
};

SubscriptionView.propTypes = {
  reactTableData: PropTypes.shape({
    tableHeaderData: PropTypes.arrayOf(PropTypes.shape({
      key: PropTypes.string,
      name: PropTypes.string,
    })),
    tableRowsData: PropTypes.arrayOf(PropTypes.shape()),
  }).isRequired,
};

export default SubscriptionView;
